import e,{Fragment as t}from"react";import o from"styled-components";import{calculateRem as a}from"@vds-core/utilities";import{LayoutTokens as n}from"@vds-tokens/layout";import"../Controls/PaginationStepControl.js";import r from"../Controls/PaginationListItem.js";import i from"../Controls/PaginationLink.js";import s from"../utilities/sharedDefaultProps.js";import l from"../utilities/sharedPropTypes.js";const p=o(r).withConfig({displayName:"PaginationNumbersContainer",componentId:"VDS__sc-edp5oz-0"})`
  display: flex;
  height: ${a("16px")};
  justify-content: center;
  min-width: ${a("20px")};

  ${({index:e,startRange:t})=>e!==t&&`margin-left: ${a(n.space["1X"].value)};`}
`,m=o.span.withConfig({displayName:"StyledSpan",componentId:"VDS__sc-edp5oz-1"})`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  svg {
    margin-top: -1px;
  }
`,c=o=>{const{total:a,selectedPage:n,baseUrl:r,selectPage:s,fixedWidth:l,surface:c,calculateRange:d,focusBorderRadius:f}=o,{startRange:u,endRange:g}=d(n,a);function y(e){s(e)}return e.createElement(t,null,Array.from({length:a+1},((e,t)=>t)).map(((t,o)=>o>=u&&o<=g&&0!==o&&e.createElement(p,{fixedWidth:l,key:o,startRange:u,index:o},e.createElement(i,{pageNumber:o,selectedPage:n,baseUrl:r,onClick:y,surface:c,focusBorderRadius:f,total:a},e.createElement(m,null,o))))))};c.propTypes=l,c.defaultProps=s;export{c as default};
